import { render, staticRenderFns } from "./SuorganizatorForma.vue?vue&type=template&id=719108da&scoped=true&"
import script from "./SuorganizatorForma.vue?vue&type=script&lang=js&"
export * from "./SuorganizatorForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719108da",
  null
  
)

export default component.exports